import { env } from "../env";

type Context = "account" | "cart" | "crm" | "product";

export default function getAuth(context?: Context) {
  let auth = "Basic ";
  switch (context) {
    case "account": {
      auth += Buffer.from(
        [env.ACCOUNT_SERVICE_USERNAME, env.ACCOUNT_SERVICE_PASSWORD].join(":")
      ).toString("base64");
      break;
    }
    case "cart": {
      auth += Buffer.from(
        [env.CART_SERVICE_USERNAME, env.CART_SERVICE_PASSWORD].join(":")
      ).toString("base64");
      break;
    }
    case "crm": {
      auth += Buffer.from(
        [env.CRM_SERVICE_USERNAME, env.CRM_SERVICE_PASSWORD].join(":")
      ).toString("base64");
      break;
    }
    case "product": {
      auth += Buffer.from(
        [env.PRODUCT_SERVICE_USERNAME, env.PRODUCT_SERVICE_PASSWORD].join(":")
      ).toString("base64");
      break;
    }
    default: {
      auth += Buffer.from(
        [env.SERVICE_USERNAME, env.SERVICE_PASSWORD].join(":")
      ).toString("base64");
      break;
    }
  }
  return auth;
}
